import { buildManagePageQueryString } from "./helpers/buildManagePageQueryString";
import { jumboMediaAPI } from "./service";


export const productionCompaniesAPI = jumboMediaAPI.injectEndpoints({
    endpoints: (build) => ({
        getProductionCompanies: build.query({
            query: (body) => `/api/Suppliers/DataTablesSource${buildManagePageQueryString(body.columns, body.page, body.searchTerm, (body.page - 1) * body.limit, body.limit, body.orderColumnIndex, body.isDescSortDir)}`,
        }),
        getAllProductionCompanies: build.query({
            query: (body) => ({
                url: `/api/Suppliers/UserGet`,
                responseHandler: (res: any) => res.json().then((res: any) => {
                    if (body?.asSelectOptions) {
                        return res.map((item: any) => ({ value: item.Id, label: item.Name }))
                    } else {
                        return res;
                        // .map((item: any) => ({ id: item.Id, name: item.Name }))
                    }
                }),
            })
        }),
        createProductionCompanyShort: build.mutation({
            query: (body) => ({
                url: `api/Clients/UserPostProductionCompany`,
                method: 'POST',
                body,
            })
        }),
        createProductionCompany: build.mutation({
            query: (body) => ({
                url: `api/Suppliers/AdminPost`,
                method: 'POST',
                body,
            })
        }),
        updateProductionCompany: build.mutation({
            query: (body) => {
                return {
                    url: `api/Suppliers/AdminPut/${body.Id}`,
                    method: 'PUT',
                    body,
                }
            }
        }),
        deleteProductionCompany: build.mutation({
            query: (body) => ({
                url: `api/Suppliers/AdminDelete/${body.id}`,
                method: 'DELETE',
            }),
        }),
    }),
})

export const {
    useGetProductionCompaniesQuery,
    useCreateProductionCompanyMutation,
    useUpdateProductionCompanyMutation,
    useDeleteProductionCompanyMutation,
    useGetAllProductionCompaniesQuery,
    useCreateProductionCompanyShortMutation,
    useLazyGetAllProductionCompaniesQuery,
} = productionCompaniesAPI;